import { newsFeed } from "@/mocks/gossip";
import { SectionHead, Tag, type Tone } from "./ui";

const catTone: Record<string, Tone> = {
  综艺: "accent",
  明星: "primary",
  网红: "secondary",
  娱乐圈: "primary",
  影剧: "accent",
  体娱: "secondary",
};

const quickLinks = [
  { icon: "ri-user-star-line", label: "明星八卦", href: "#star", desc: "影剧圈的暗涌与明争" },
  { icon: "ri-vidicon-line", label: "网红主播", href: "#streamer", desc: "带货与直播的流量江湖" },
  { icon: "ri-file-shield-2-line", label: "实锤档案", href: "#impact", desc: "冷暖、翻车与反转全归档" },
  { icon: "ri-newspaper-line", label: "最新动态", href: "#news", desc: "今日瓜讯一手速递" },
];

export default function NewsFeed() {
  return (
    <section id="news" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-10 md:px-6 md:py-16">
        <SectionHead
          eyebrow="Live · 一手动态"
          title="最新动态：今天娱乐圈在发生什么"
          sub="按时间倒序滚动更新，覆盖明星行程、网红直播、综艺录制与娱乐行业动态，点开即知刚刚发生什么。"
        />
        <div className="grid gap-8 lg:grid-cols-12">
          {/* 信息流 */}
          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-100/40">
              {newsFeed.map((f) => (
                <article key={f.title} className="group flex items-start gap-4 p-4 transition hover:bg-background-50 md:p-5">
                  <span className="font-heading mt-0.5 hidden w-14 shrink-0 text-lg font-black text-primary-600 sm:block">{f.time}</span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <Tag tone={catTone[f.tag] ?? "secondary"}>{f.tag}</Tag>
                      <span className="text-xs text-foreground-400 sm:hidden">{f.time}</span>
                    </div>
                    <h3 className="font-heading mt-2 text-base font-bold text-foreground-950 transition group-hover:text-primary-700">
                      <a href="#star">{f.title}</a>
                    </h3>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{f.excerpt}</p>
                  </div>
                  <i className="ri-arrow-right-up-line mt-1.5 shrink-0 text-foreground-300 transition group-hover:text-primary-500" />
                </article>
              ))}
            </div>
            <div className="mt-5 text-center">
              <a
                href="#star"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-700 transition hover:border-primary-300 hover:text-primary-700"
              >
                查看更多今日瓜讯
                <i className="ri-arrow-down-line" />
              </a>
            </div>
          </div>

          {/* 侧栏栏目导航 */}
          <aside className="lg:col-span-4">
            <div className="rounded-2xl border border-background-200 bg-background-100/50 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">追瓜栏目 · 快速直达</h3>
              <div className="mt-4 space-y-3">
                {quickLinks.map((q) => (
                  <a
                    key={q.href}
                    href={q.href}
                    className="group flex items-center gap-4 rounded-xl bg-background-50 p-3.5 transition hover:bg-primary-50"
                  >
                    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-primary-100 text-lg text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50">
                      <i className={q.icon} />
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-foreground-900">{q.label}</span>
                      <span className="mt-0.5 block text-xs text-foreground-500">{q.desc}</span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
            <div className="mt-5 overflow-hidden rounded-2xl bg-primary-500 p-6 text-background-50">
              <p className="text-xs font-semibold tracking-[0.2em] text-background-50/80">每日瓜报</p>
              <p className="font-heading mt-2 text-xl font-bold leading-snug">不想错过重点？订阅「刚刚爆料」追瓜快讯，每天一份热瓜精选送到你手上。</p>
              <a
                href="#join"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-primary-700 transition hover:bg-accent-100"
              >
                去订阅
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}